export const SELECT_TYPE = {
  SuggestBudget: 'Suggest',
  ManualBudget: 'Manual',
};

export const COMMENT_TYPES = {
  SUGGESTED: 'Suggested',
  CURRENT: 'Current',
  MAXVALUE: 'MaxValue',
};
